// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");
var Link = require("./link");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Fetch = require("bs-fetch/lib/js/src/Fetch.js");
var Theme = require("./theme");
var React = require("react");
var Network = require("./network");
var Json_encode = require("@glennsl/bs-json/lib/js/src/Json_encode.bs.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var resetExec = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(0)),
      /* :: */[
        Css.fontWeight(700),
        /* [] */0
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(5), Css.px(0), Css.px(8), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var Styles = /* module */[
  /* card */card,
  /* resetExec */resetExec,
  /* inputHeader */inputHeader,
  /* inputField */inputField,
  /* someLink */someLink
];

function text(prim) {
  return prim;
}

function validatePassword(value) {
  var match = +(value.length > 5);
  if (match !== 0) {
    return /* PassValid */0;
  } else {
    return /* PassNotValid */["Password zu kurz"];
  }
}

function showApiError(data, self, message) {
  return Promise.resolve(data).then((function () {
                  console.log("Login error!");
                  Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(2, [message]));
                  return Promise.resolve(/* () */0);
                })).catch((function (err) {
                return Promise.resolve((console.log("API error exception", err), /* () */0));
              }));
}

var component = ReasonReact.reducerComponent("ResetExec");

function make(resetCode, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function (param) {
      var send = param[/* send */4];
      var state = param[/* state */2];
      var match = state[/* error */2];
      var match$1 = state[/* success */3];
      var match$2 = state[/* loading */4];
      return React.createElement("div", {
                  className: resetExec
                }, React.createElement("h1", undefined, "Passwort Reset"), React.createElement("p", undefined, "Bitte gebe zum Reset deines Passworts deine Email Adresse ein. Wir senden dir einen Reset Link zu."), React.createElement("p", {
                      className: inputHeader
                    }, "Token"), React.createElement("input", {
                      className: inputField,
                      placeholder: "Token",
                      type: "text",
                      value: state[/* token */1],
                      onChange: (function ($$event) {
                          return Curry._1(send, /* ChangeToken */Block.__(0, [$$event.target.value]));
                        })
                    }), React.createElement("p", {
                      className: inputHeader
                    }, "Passwort"), React.createElement("input", {
                      className: inputField,
                      autoFocus: true,
                      placeholder: "Passwort",
                      type: "password",
                      value: state[/* password */0],
                      onKeyDown: (function ($$event) {
                          if ($$event.keyCode === 13) {
                            $$event.preventDefault();
                            return Curry._1(send, /* ResetExecEnterKeyDown */1);
                          } else {
                            return Curry._1(send, /* ResetExecOtherKeyDown */0);
                          }
                        }),
                      onChange: (function ($$event) {
                          return Curry._1(send, /* ChangePassword */Block.__(1, [$$event.target.value]));
                        })
                    }), match ? React.createElement("div", {
                        className: "failure"
                      }, match[0]) : null, match$1 ? React.createElement("div", {
                        className: "success"
                      }, match$1[0]) : null, React.createElement("button", {
                      className: "login-button",
                      onClick: (function () {
                          return Curry._1(send, /* ResetExec */2);
                        })
                    }, match$2 !== 0 ? React.createElement("div", {
                            className: "button-spinner"
                          }) : "Absenden"), ReasonReact.element(/* None */0, /* None */0, Link.make("/login", "zum Login", someLink, /* array */[])));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* password */"",
              /* token */resetCode,
              /* error : None */0,
              /* success : None */0,
              /* loading : false */0
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        switch (action) {
          case 0 : 
              return /* NoUpdate */0;
          case 1 : 
              return /* SideEffects */Block.__(2, [(function (self) {
                            return Curry._1(self[/* send */4], /* ResetExec */2);
                          })]);
          case 2 : 
              var passwordValid = validatePassword(state[/* password */0]);
              if (passwordValid) {
                var error = passwordValid[0];
                return /* SideEffects */Block.__(2, [(function (self) {
                              return Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(2, [error]));
                            })]);
              } else {
                return /* UpdateWithSideEffects */Block.__(3, [
                          /* record */[
                            /* password */state[/* password */0],
                            /* token */state[/* token */1],
                            /* error */state[/* error */2],
                            /* success */state[/* success */3],
                            /* loading : true */1
                          ],
                          (function (self) {
                              var requestPayload = Json_encode.object_(/* :: */[
                                    /* tuple */[
                                      "password",
                                      self[/* state */2][/* password */0]
                                    ],
                                    /* :: */[
                                      /* tuple */[
                                        "password_reset_token",
                                        self[/* state */2][/* token */1]
                                      ],
                                      /* [] */0
                                    ]
                                  ]);
                              fetch(Network.resetExecUrl, Fetch.RequestInit[/* make */0](/* Some */[/* Put */3], /* Some */[{
                                                "Content-Type": "application/json",
                                                Accept: "application.json"
                                              }], /* Some */[JSON.stringify(requestPayload)], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0)(/* () */0)).then((function (data) {
                                        var statusCode = data.status;
                                        console.log("https status: ", statusCode);
                                        if (statusCode !== 200) {
                                          if (statusCode !== 404) {
                                            return showApiError(data, self, "Http Fehler: " + String(statusCode));
                                          } else {
                                            return showApiError(data, self, "Token nicht gültig");
                                          }
                                        } else {
                                          console.log("ResetExec executed");
                                          Curry._1(self[/* send */4], /* ShowSuccessMessage */Block.__(3, ["Dein Password wurde erfolgreich zurückgesetzt"]));
                                          return Promise.resolve(/* () */0);
                                        }
                                      })).catch((function (err) {
                                      return Promise.resolve((console.log("Api error", err), Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(2, ["Netzwerkfehler"]))));
                                    }));
                              return /* () */0;
                            })
                        ]);
              }
          case 3 : 
              return /* Update */Block.__(0, [/* record */[
                          /* password */state[/* password */0],
                          /* token */state[/* token */1],
                          /* error : None */0,
                          /* success */state[/* success */3],
                          /* loading */state[/* loading */4]
                        ]]);
          
        }
      } else {
        switch (action.tag | 0) {
          case 0 : 
              return /* Update */Block.__(0, [/* record */[
                          /* password */state[/* password */0],
                          /* token */action[0],
                          /* error */state[/* error */2],
                          /* success */state[/* success */3],
                          /* loading */state[/* loading */4]
                        ]]);
          case 1 : 
              return /* Update */Block.__(0, [/* record */[
                          /* password */action[0],
                          /* token */state[/* token */1],
                          /* error */state[/* error */2],
                          /* success */state[/* success */3],
                          /* loading */state[/* loading */4]
                        ]]);
          case 2 : 
              var text = action[0];
              return /* UpdateWithSideEffects */Block.__(3, [
                        /* record */[
                          /* password */state[/* password */0],
                          /* token */state[/* token */1],
                          /* error : Some */[text],
                          /* success */state[/* success */3],
                          /* loading : false */0
                        ],
                        (function (self) {
                            console.log("ShowErrorMessage Reducer:", text);
                            setTimeout((function () {
                                    return Curry._1(self[/* send */4], /* ClearError */3);
                                  }), 2500);
                            return /* () */0;
                          })
                      ]);
          case 3 : 
              var text$1 = action[0];
              return /* UpdateWithSideEffects */Block.__(3, [
                        /* record */[
                          /* password */state[/* password */0],
                          /* token */state[/* token */1],
                          /* error */state[/* error */2],
                          /* success : Some */[text$1],
                          /* loading : false */0
                        ],
                        (function () {
                            console.log("ShowSuccessMessage Reducer:", text$1);
                            setTimeout((function () {
                                    return ReasonReact.Router[/* push */0]("/");
                                  }), 3000);
                            return /* () */0;
                          })
                      ]);
          
        }
      }
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.validatePassword = validatePassword;
exports.showApiError = showApiError;
exports.component = component;
exports.make = make;
/* card Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/resetExec.re
// module id = 144
// module chunks = 0